<template>
    <div>
        <h1 class="title-section-bold-blue text-center">
            Depoimentos
        </h1>
        <div class="space-x-5">
            <div class="md:grid md:grid-cols-7">
                <div
                    v-if="comments.length > 1"
                    class="h-full hidden md:flex items-center"
                >
                    <img
                        class="cursor-pointer"
                        src="/assets/images/comentario_anterior_btn.png"
                        alt="Comentário anterior sobre a empresa PC4"
                        @click="beforePhoto"
                    >
                </div>
                <div
                    id="carousel-drag-comment"
                    :class="`${comments.length > 1? 'col-span-5' : 'col-span-7 2xl:col-start-2 2xl:col-span-5'}`"
                    class="md:px-8  flex flex-col items-end justify-between carousel-draggable-comment text-select-removal"
                >
                    <blockquote>
                        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 0H10L8 4V10H14V4H11L13 0ZM5 0H2L0 4V10H6V4H3L5 0Z" fill="#253858"/></svg>
                        <h3 class="pl-5 pr-3">
                            {{showingComment.comment}}
                        </h3>
                        <div class="flex justify-end -mt-5">
                            <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 10H4L6 6V0H0V6H3L1 10ZM9 10H12L14 6V0H8V6H11L9 10Z" fill="#253858"/></svg>
                        </div>
                    </blockquote>
                    <div>
                        <div>
                            <div>
                                <div class="text-blue-800 font-semibold text-xl text-right mt-7">
                                    {{showingComment.commenterName}}
                                </div>
                                <div class="mb-2 md:mb-4 text-xl text-right">
                                    {{showingComment.commenterPosition}}
                                </div>
                            </div>
                            <div class="flex justify-end">
                                <img
                                    class="logo-img"
                                    :src="`/assets/images/testimonials/${showingComment.logo}`"
                                    :alt="`Logo da empresa ${showingComment.logo.split('_')[0]}`"
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-if="comments.length > 1"
                    class="hidden h-full md:flex items-center justify-end"
                >
                    <img
                        class="cursor-pointer"
                        src="/assets/images/proximo_comentario_btn.png"
                        alt="Próximo comentário sobre a empresa PC4"
                        @click="afterPhoto"
                    >
                </div>
            </div>
        </div>
        <div class="block md:hidden"></div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted, computed } from 'vue';

const props = defineProps({
    comments: {
        type: Array,
        required: false,
        default: () => [],
    },
});

onMounted(() => {
    ele.value?.addEventListener('touchstart', touchDownHandler);
});

const showingComment = computed(() => props.comments[commentShowingIndex.value]);

const ele = ref(document.getElementById('carousel-drag-comment'));
const pos = ref({ top: 0, left: 0, x: 0, y: 0 });
const commentShowingIndex = ref(0);

const touchDownHandler = (e) => {
    pos.value = {
        // The current scroll
        left: ele.value?.scrollLeft || 0,
        top: ele.value?.scrollTop || 0,
        // Get the current mouse position
        x: e.touches[0].clientX,
        y: e.touches[0].clientY,
    };
    document.addEventListener('touchmove', touchmoveHandler);
    document.addEventListener('touchend', touchUpHandler);
};

const touchmoveHandler = (e) => {
    const dx = e.touches[0].clientX - pos.value.x;
    if (dx < - 50) afterPhoto();
    else if (dx > 50) beforePhoto();
};

const touchUpHandler = () => {
    document.removeEventListener('touchmove', touchmoveHandler);
    //document.removeEventListener('touchend', this.mouseUpHandler);
};

const beforePhoto = () => {
    if (commentShowingIndex.value !== 0) {
        commentShowingIndex.value--;
    } else {
        commentShowingIndex.value = props.comments.length - 1;
    }
};

const afterPhoto = () => {
    if ((commentShowingIndex.value + 1) < props.comments.length) {
        commentShowingIndex.value++;
    } else {
        commentShowingIndex.value = 0;
    }
};

const _timerId = ref();

watch(
    () => commentShowingIndex.value,
    () => {
        clearInterval(_timerId.value);

        _timerId.value = setInterval(() => {
            if (commentShowingIndex.value === props.comments.length - 1) {
                commentShowingIndex.value = 0

            } else {
                commentShowingIndex.value++
            }
        }, 7000);
    }
);
/*
export default {
    props: {
        comments: {
            type:Array,
            required: false,
            default: () => [],
        }
    },
    data(){
        return {
            ele: {},
            pos : { top: 0, left: 0, x: 0, y: 0 },
            commentShowingIndex:0,
        }
    },
    computed:{
        showingComment(){
            return this.comments[this.commentShowingIndex];
        }
    },
    watch:{
        commentShowingIndex:{
            immediate:true,
            handler(newValue){
                clearInterval(this._timerId)
                this._timerId = setInterval(() => {
                    this.afterPhoto();
                }, 7000);
            }
        }
    },
    mounted(){
        this.ele = document.getElementById('carousel-drag-comment');
        this.ele.addEventListener('touchstart', this.touchDownHandler);
    },
    methods:{
        touchDownHandler(e){
            this.pos = {
                // The current scroll
                left: this.ele.scrollLeft,
                top: this.ele.scrollTop,
                // Get the current mouse position
                x: e.touches[0].clientX,
                y: e.touches[0].clientY,
            };
            document.addEventListener('touchmove', this.touchmoveHandler);
            document.addEventListener('touchend', this.touchUpHandler);
        },

        touchmoveHandler(e){
            const dx = e.touches[0].clientX - this.pos.x;
            if(dx < - 50) this.afterPhoto();
            else if(dx > 50) this.beforePhoto();
        },

        touchUpHandler () {
            document.removeEventListener('touchmove', this.touchmoveHandler);
            document.removeEventListener('touchend', this.mouseUpHandler);
        },
        beforePhoto(){
            if(this.commentShowingIndex !== 0){
                this.commentShowingIndex--;
            } else {
                this.commentShowingIndex = this.comments.length -1;
            }
        },
        afterPhoto(){
            if((this.commentShowingIndex + 1) < this.comments.length){
                this.commentShowingIndex++;
            } else {
                this.commentShowingIndex = 0;
            }
        },
    },
}
*/
</script>

<style lang="postcss" scoped>
.carousel-draggable-comment {

    @media (max-width: 768px) {
        max-width: 90vw;
    }

    overflow: auto;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */

    @apply flex space-x-10 md:space-x-20;

    &::-webkit-scrollbar {
        display: none;
    }
}

.text-select-removal {
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    -webkit-user-select:none;
    -khtml-user-select:none;
    -moz-user-select:none;
    -o-user-select:none;
    user-select:none;
}

.logo-img {
    max-width: 100px;
    max-height: 50px;
}
</style>
